import _ from 'lodash';
import NamedDto from 'modules/base/dto/NamedDto';

export default class PiMeasurementReaderFieldEditDto extends NamedDto {
	constructor() {
		super();
		/** @type {string} */
		this.tag_name = null;
		/** @type {string} */
		this.uom = null;
		/** @type {string} */
		this.category = null;
		/** @type {string} */
		this.type = null;
		/** @type {string} */
		this.expression = null;
		/** @type {string} */
		this.value = null;
	}

	/**
	 * @typedef {Object} _PiMeasurementReaderFieldEditDtoProps
	 * @property {string} tag_name
	 * @property {string} uom
	 * @property {string} category
	 * @property {string} type
	 * @property {string} expression
	 * @property {string} value
	 *
	 * @typedef {import("modules/base/dto/NamedDto").NamedDtoProps & _PiMeasurementReaderFieldEditDtoProps} PiMeasurementReaderFieldEditDtoProps
	 */
	/**
	 *
	 * @param {PiMeasurementReaderFieldEditDtoProps} props
	 * @returns {PiMeasurementReaderFieldEditDto}
	 */
	setup(props) {
		super.setup(props);
		this.tag_name = props.tag_name;
		this.uom = props.uom;
		this.category = props.category;
		this.type = props.type;
		this.expression = props.expression;
		this.value = props.value;
		return this;
	}
}
